import { render } from "./ShiftCosts.vue?vue&type=template&id=45a7ca94&scoped=true&ts=true"
import script from "./ShiftCosts.ts?vue&type=script&lang=ts"
export * from "./ShiftCosts.ts?vue&type=script&lang=ts"

import "./ShiftCosts.vue?vue&type=style&index=0&id=45a7ca94&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a7ca94"]])

export default __exports__